<template lang="html">
  <div class="cover-popup row-center">
    <div class="popup">
      <h2 class="title-pop">{{ $t("popup_documentacion_alumno.atencion") }}</h2>

      <div v-html="$t('popup_documentacion_alumno.cuerpo')"></div>

      <div class="contenedor-botones">
        <button class="btn -solid-primary" @click="cerrarPopup">
          {{ $t("popup_documentacion_alumno.btn_cta") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  export default  {
    name: 'popup-documentacion-alumno',
  mounted() {

    },
    computed : {
      ...mapGetters({
        brand:'getBrand',
        style : 'getStyles'
      })
    },
    methods : {
      ...mapActions(['setPopupDocumentacionTrue']),
      cerrarPopup() {
        this.setPopupDocumentacionTrue();
        window.localStorage.setItem("PopupDocumentacionAlumno", true);
      }
    }
  }
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/parts/popup-documentacion-alumno.vue